import React from "react"
import { ExitIcon } from "@100mslive/react-icons"
import { useWebinarAppContext } from "../state"
import { Header } from "./header"
import {
  defaultPreviewPreference,
  UserPreferencesKeys,
  useUserPreferences,
} from "./hooks/useUserPreferences"
import Flex from "./shared/flex"
import { Box } from "./shared/box"
import { Text } from "./shared/text"
import { WebinarButton } from "./shared/button/webinar-button"
import { useToast } from "./hooks/useToast"

const PostLeave = () => {
  const { goToPreview } = useWebinarAppContext()
  const toast = useToast()
  const [previewPreference] = useUserPreferences(
    UserPreferencesKeys.PREVIEW,
    defaultPreviewPreference,
  )
  return (
    <Flex css={{ height: "100%", flexDirection: "column" }} justify="center" align="center">
      <Box data-testid="header">
        <Header isPreview />
      </Box>
      <Flex
        justify="center"
        direction="column"
        align="center"
        gap="0"
        css={{
          flex: "1 1 0",
          position: "relative",
          padding: "3rem",
          marginBottom: "6rem",
        }}
      >
        <Text variant="h2" css={{ fontWeight: "$semiBold", margin: 0, fontSize: "6rem" }}>
          👋
        </Text>
        <Text
          variant="h4"
          css={{
            fontSize: "3.4rem",
            fontWeight: "500",
            margin: "0",
            marginTop: "3.2rem",
            textAlign: "center",
          }}
        >
          You left the Webinar
        </Text>
        <Text
          variant="body1"
          css={{
            color: "$textMedEmp",
            textAlign: "center",
            fontSize: "1.6rem",
            fontWeight: "400",
            margin: "0",
            marginTop: "1.2rem",
          }}
        >
          Have a nice day,
          {previewPreference.name && (
            <Box as="span" css={{ fontWeight: "500" }}>
              {" "}
              {previewPreference.name}
            </Box>
          )}
          !
        </Text>
        <Flex
          justify="space-between"
          css={{ width: "26rem", alignItems: "center", margin: "0", marginTop: "3rem" }}
        >
          <Text variant="body1" css={{ color: "$textMedEmp", fontWeight: "$regular" }}>
            Left by mistake?
          </Text>
          <WebinarButton
            height="4rem"
            width="11rem"
            onClick={() => {
              goToPreview()
              toast.clearAllToast()
            }}
            data-testid="join_again_btn"
          >
            <ExitIcon />
            <Text css={{ fontWeight: "$semiBold", color: "inherit", margin: "0" }}>Rejoin</Text>
          </WebinarButton>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default PostLeave
